import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ScApiService } from '@sc-ui';
import { texts } from './login.texts';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  texts = texts;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ScApiService) { }

  requestedUserId: number;

  eMail: string;

  password: string;

  successMessage: string = "";

  loginError: any;

  resetError: string;

  eMailError: string;

  passwordError: string;

  showPasswordReset: boolean;

  target: string = '/dashboard';

  secret: string;

  isSending: boolean = false;

  ngOnInit() {

    // this.api.get('me').subscribe((d: any) => {
    //   if (d.IsLoggedIn && (!this.requestedUserId || this.requestedUserId == d.Id)) {
    //     this.navigate();
    //   }
    // });

    this.route.queryParams
      .subscribe(params => {

        this.target = params['target'] ?? this.target;
        this.secret = params['secret'] ?? this.secret;
        this.eMail = params['eMail'] ?? this.eMail;
        this.requestedUserId = params['u'] ?? this.requestedUserId;

        this.api.get('me').subscribe((d: any) => {

          var isUserIdOk = !this.requestedUserId || this.requestedUserId == d.Id;
          var isEMailOk = !this.eMail || this.eMail == d.EMail;

          if (d.IsLoggedIn && isUserIdOk && isEMailOk) {
            this.navigate();
          }
        });

        

      });
  }

  login() {

    this.loginError = "";
    this.resetError = "";
    this.eMailError = "";
    this.passwordError = "";
    this.successMessage = "";

    if (!this.password && !this.eMail) {
      this.loginError = texts.errors.missingBoth;
      return;
    }

    if (!this.password) {
      this.loginError = texts.errors.missingPassword;
      return;
    }

    if (!this.eMail) {
      this.loginError = texts.errors.missingEmail;
      return;
    }

    this.isSending = true;

    this.api.login(this.eMail, this.password).subscribe(
      (d: any) => {

        this.isSending = false;

        if (d.Succeeded) {

          if (!this.secret) {
            this.navigate();
          }
          else {
            var arg = {
              Secret: this.secret
            };

            this.api.post("account/merge", arg).subscribe(
              d => {
                this.navigate();
              },
              error => {
                this.loginError = texts.errors.mergeFailed;
              })
          }
        }

        else {
          if (d.IsRegistered == false && d.CanRegister) {
            this.router.navigateByUrl(`/register-send-link?eMail=${this.eMail}`);
          }
          if (d.IsRegistered == false && d.CanRegister == false) {
            this.router.navigateByUrl(`/register-forbidden?eMail=${this.eMail}`);
          }
          this.loginError = d.Error;
        }
      },
      error => {
        console.log(error);
        this.isSending = false;
        if (error.message)
          this.loginError = error.message;
        else
          this.loginError = texts.errors.generic;
      });
  }

  navigate() {
    this.router.navigateByUrl(this.target);
  }

  forgotPassword() {
    this.router.navigateByUrl(`/forgot-pw?eMail=${this.eMail}`);
  }


}
